module.exports = __webpack_public_path__ + "static/media/Stepping Heedful-30sec.77d8367e.mp3";